import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import * as PropTypes from 'prop-types';
import classNames from 'classnames';
var wrapStyle = {
  display: 'inline-block'
};

var Textarea = /*#__PURE__*/function (_React$Component) {
  _inherits(Textarea, _React$Component);

  var _super = _createSuper(Textarea);

  function Textarea() {
    var _this;

    _classCallCheck(this, Textarea);

    _this = _super.apply(this, arguments);
    _this.state = {
      len: 0
    };

    _this.handleChange = function (e) {
      var onChange = _this.props.onChange;

      if (onChange) {
        onChange(e);
      }

      _this.setState({
        len: e.target.value.length
      });
    };

    _this.renderT = function () {
      var _a = _this.props,
          className = _a.className,
          statistics = _a.statistics,
          value = _a.value,
          defaultValue = _a.defaultValue,
          onChange = _a.onChange,
          resize = _a.resize,
          style = _a.style,
          restProps = __rest(_a, ["className", "statistics", "value", "defaultValue", "onChange", "resize", "style"]);

      var resizeStyle = _Object$assign({
        resize: resize
      }, style);

      return /*#__PURE__*/React.createElement("textarea", _Object$assign({}, restProps, {
        value: value,
        style: resizeStyle,
        defaultValue: defaultValue,
        onChange: _this.handleChange,
        className: classNames('roo-input', className)
      }));
    };

    return _this;
  }

  _createClass(Textarea, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          statistics = _this$props.statistics,
          maxLength = _this$props.maxLength;

      if (statistics) {
        return /*#__PURE__*/React.createElement("div", {
          style: wrapStyle
        }, this.renderT(), /*#__PURE__*/React.createElement("p", null, this.state.len, maxLength ? " / ".concat(maxLength) : ''));
      }

      return this.renderT();
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if (nextProps.defaultValue) {
        return {
          len: nextProps.defaultValue.length
        };
      }

      if (nextProps.value) {
        return {
          len: nextProps.value.length
        };
      }

      return null;
    }
  }]);

  return Textarea;
}(React.Component);

Textarea.rooName = 'RTextarea';
Textarea.defaultProps = {
  defaultValue: undefined,
  value: undefined,
  placeholder: undefined,
  className: undefined,
  style: undefined,
  statistics: false,
  onChange: function onChange() {}
};
Textarea.propTypes = {
  defaultValue: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  statistics: PropTypes.bool,
  onChange: PropTypes.func
};
export default Textarea;